import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import "./Login.css";
import API_URL from "./apiConfig";

const Login = ({ onSwitchToRegister, onLoginSuccess }) => {
  const [role, setRole] = useState("customer"); // 'customer' or 'vendor'
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Please fill in all fields.");
      return;
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }
    try {
      const response = await fetch(
        `${API_URL}/api/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password, role }),
        },
      );
      const data = await response.json();
      if (response.ok) {
        alert(
          `${role.charAt(0).toUpperCase() + role.slice(1)} Login successful!`,
        );
        localStorage.setItem("token", data.token);
        localStorage.setItem("userRole", role);
        localStorage.setItem("user", JSON.stringify(data.user));
        if (onLoginSuccess) onLoginSuccess(role);
      } else {
        alert(data.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert(
        "Cannot connect to the server. Please ensure the backend is running.",
      );
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await fetch(
        `${API_URL}/api/auth/google-login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: credentialResponse.credential, role }),
        },
      );
      const data = await response.json();
      if (response.ok) {
        alert("Google Login successful!");
        localStorage.setItem("token", data.token);
        localStorage.setItem("userRole", role);
        localStorage.setItem("user", JSON.stringify(data.user));
        if (onLoginSuccess) onLoginSuccess(role);
      } else {
        alert(data.message || "Google Login failed");
      }
    } catch (error) {
      console.error("Google Login error:", error);
      alert("Cannot connect to the server");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>{role === "customer" ? "Customer Login" : "Vendor Login"}</h1>
          <p>Experience the best of Below2000</p>
        </div>

        <div className="role-selector">
          <button
            className={role === "customer" ? "active" : ""}
            onClick={() => setRole("customer")}
          >
            Customer
          </button>
          <button
            className={role === "vendor" ? "active" : ""}
            onClick={() => setRole("vendor")}
          >
            Vendor
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">
            Login as {role.charAt(0).toUpperCase() + role.slice(1)}
          </button>
        </form>

        <div className="separator">
          <span>OR</span>
        </div>

        <div className="google-login-wrapper">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => alert("Google Login Failed")}
            useOneTap
          />
        </div>

        <div className="login-footer">
          <p>
            Don't have an account?{" "}
            <span className="signup-link" onClick={onSwitchToRegister}>
              Sign Up
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
